var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwmsRecTopSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 344,
    height: 86.024,
    viewBox: "0 0 344 86.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe3908"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1764",
    "data-name": "Group 1764",
    transform: "translate(-847 -2635.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1761",
    "data-name": "Group 1761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1049",
    "data-name": "Rectangle 1049",
    d: "M25,0H318a26,26,0,0,1,26,26V51a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V25A25,25,0,0,1,25,0Z",
    transform: "translate(847 2654)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1703",
    "data-name": "Group 1703",
    transform: "translate(-481.715 589.166) rotate(-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5870",
    "data-name": "Path 5870",
    d: "M0,0,11.706,16.752H0Z",
    transform: "translate(1135.528 2227.707) rotate(7)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5873",
    "data-name": "Path 5873",
    d: "M54.329,82.563l-45.087.9c-6.21.125-11.143-4-11.019-9.208L0,0,67.575-1.356,65.8,72.9C65.674,78.113,60.539,82.438,54.329,82.563Z",
    transform: "translate(1068.291 2219.451) rotate(7)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1763",
    "data-name": "Group 1763"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Exclusive_Limited_Of_fer_",
    "data-name": "Exclusive Limited Of fer!",
    transform: "translate(962.869 2686)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Outfit-Bold, Outfit",
    fontWeight: 700,
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Exclusive Limited O"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.2em"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.054em"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "er!")), /*#__PURE__*/React.createElement("text", {
    id: "Save_20_",
    "data-name": "Save  20%",
    transform: "translate(898 2668)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Outfit-Bold, Outfit",
    fontWeight: 700,
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Save"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 23
  }), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 23
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 27
  }, "20%")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwmsRecTopSvg);
export default __webpack_public_path__ + "static/media/awms_rec_top_svg.a9071ea0d4b5e357155980472e8f29fd.svg";
export { ForwardRef as ReactComponent };